import {Controller} from "@hotwired/stimulus";
import axios from "axios";

export default class extends Controller {


    articleGtag(e) {
      const href = e.currentTarget.href
      e.preventDefault();
        const locale = window.location.pathname.split("/")[1].toUpperCase();
        gtag("event", "select_article", {
            language: locale.length > 2 || !locale ? "EN" : locale,
            title: e.params.title,
            category: e.params.category,
            index: e.params.index
        });
      if (typeof rdt === "function") {
        rdt("track", "Custom", { customEventName: "select_article" });
      }
      setTimeout(() => {
        window.location.href = href;
      }, 150)
    }
    shareArticleGtag(e) {
        const locale = window.location.pathname.split("/")[1].toUpperCase();
        gtag("event", "share_article", {
            language: locale.length > 2 || !locale ? "EN" : locale,
            title: e.params.title,
            category: e.params.category,
            index: e.params.index,
            network: e.params.network
        });
      if (typeof rdt === "function") {
        rdt("track", "Custom", { customEventName: "share_article" });
      }
    }
}